/***********************************************************************
 *                           date工具类                           *
 * ********************************************************************/

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18

/**
 * 方法作用：【格式化时间】
 * 使用方法
 * 示例：
 *      使用方式一：
 *      var now = new Date();
 *      var nowStr = now.dateFormat("yyyy-MM-dd hh:mm:ss");
 *      使用方式二：
 *      new Date().dateFormat("yyyy年MM月dd日");
 *      new Date().dateFormat("MM/dd/yyyy");
 *      new Date().dateFormat("yyyyMMdd");
 *      new Date().dateFormat("yyyy-MM-dd hh:mm:ss");
 * @param format {date} 传入要格式化的日期类型
 * @returns {2015-01-31 16:30:00}
 */
Date.prototype.Format = function(fmt) {
  var fmt = fmt || 'yyyy-MM-dd hh:mm:ss'
  var o = {
    'M+': this.getMonth() + 1, //月份
    'd+': this.getDate(), //日
    'h+': this.getHours(), //小时
    'm+': this.getMinutes(), //分
    's+': this.getSeconds(), //秒
    'q+': Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
  return fmt
}

/*
 * 方法作用：【取传入日期是星期几】
 * 使用方法：nowFewWeeks(new Date());
 * @param date{date} 传入日期类型
 * @returns {星期四，...}
 */

export function nowFewWeeks(date) {
  if (date instanceof Date) {
    var dayNames = new Array('星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六')
    console.log('=====dayNames===', dayNames)
    console.log('=====date.getDay()===', date.getDay())
    return dayNames[date.getDay()]
  } else {
    return 'Param error,date type!'
  }
}

/*
 * 方法作用：【字符串转换成日期】
 * 使用方法：strTurnDate("2010-01-01");
 * @param str {String}字符串格式的日期，传入格式：yyyy-mm-dd(2015-01-31)
 * @return {Date}由字符串转换成的日期
 */

export function strTurnDate(str) {
  var re = /^(\d{4})\S(\d{1,2})\S(\d{1,2})$/
  var dt
  if (re.test(str)) {
    dt = new Date(RegExp.$1, RegExp.$2 - 1, RegExp.$3)
  }
  return dt
}

/*
 * 方法作用：【计算2个日期之间的天数】
 * 传入格式：yyyy-mm-dd(2015-01-31)
 * 使用方法：dayMinus(startDate,endDate);
 * @startDate {Date}起始日期
 * @endDate {Date}结束日期
 * @return endDate - startDate的天数差
 */
export function dayMinus(startDate, endDate) {
  if (startDate instanceof Date && endDate instanceof Date) {
    var days = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24))
    return days
  } else {
    return 'Param error,date type!'
  }
}

export function formatTimeToStr(times, pattern) {
  var pattern = pattern || 'yyyy-MM-dd hh:mm:ss'
  var d = new Date(times).Format(pattern)
  return d.toLocaleString()
}



// WEBPACK FOOTER //
// ./src/utils/date.js